import React, { Fragment, Component } from "react";
import * as moment from "moment";
import Moment from "react-moment";
import $ from 'jquery';

class Footer extends Component {

  componentDidMount() {
    this.goToTop();
  }

  goToTop = function () {

    $('.js-gotop').on('click', function (event) {

       event.preventDefault();

       $('html, body').animate({
          scrollTop: $('html').offset().top
       }, 500);

       return false;
    });

    $(window).scroll(function () {

       var $win = $(window);
       if ($win.scrollTop() > 200) {
          $('.js-top').addClass('active');
       } else {
          $('.js-top').removeClass('active');
       }

    });

  };

  render() {
    const { showAgreement } = this.props;
    return (
      <Fragment>
        <div className="container">
          <footer className="row">
          {(showAgreement) && (
          <div className="col-sm-6 classynav">
            <ul>
            <li><a href="/game/complete_agreement#service" target="_blank" rel="noopener noreferrer">會員服務條款</a>　|</li>
            <li><a href="/game/complete_agreement#privacy" target="_blank" rel="noopener noreferrer">隱私權政策</a>　|</li>
            <li><a href="/game/complete_agreement#data_use" target="_blank" rel="noopener noreferrer">個資同意書</a>　|</li>
            <li><a href="/game/complete_agreement#rules" target="_blank" rel="noopener noreferrer">遊戲管理規則</a></li>
            </ul>
          </div>
          )}
          <div className={(showAgreement) ? "col-sm-6 copyright" : "col-sm-12 copyright"} style={(showAgreement) ? {} : {textAlign: "center"}}>Long E Co., Ltd © <Moment format="YYYY">{moment()}</Moment> Copyrights Reserved.<i className="fa fa-heart-o" aria-hidden="true"></i> </div>
          </footer>
        </div>
        <div className="gototop js-top"> <a href="#" className="js-gotop"><i className="icon-arrow-up2"></i></a> </div>
      </Fragment>
    );
    }
}

export default Footer;
